/** Anzeige-Templates der Container-View — Port von `IwmColumnsContainer.razor`. */

import type { Container } from '@/types/entities';

import { getContainerRowColor } from './rowColors';
import { CheckboxCell } from './shared/CheckboxCell';
import { DateCell } from './shared/DateCell';
import { RowColorMarker } from './shared/RowColorMarker';
import type { CellTemplateMap } from './types';

const rowColor = (model: Container) => <RowColorMarker className={getContainerRowColor(model)} />;

export const containerCellTemplates: CellTemplateMap<Container> = {
  // DateTimes
  Etd: (model) => <DateCell value={model.Etd} />,
  Eta: (model) => <DateCell value={model.Eta} />,
  Anlieferdatum: (model) => <DateCell value={model.Anlieferdatum} />,
  AnlieferdatumIst: (model) => <DateCell value={model.AnlieferdatumIst} />,
  FruehestAnlieferdatum: (model) => (
    <>
      {rowColor(model)}
      <DateCell value={model.FruehestAnlieferdatum} />
    </>
  ),
  AnlieferdatumEmpf: (model) => (
    <>
      {rowColor(model)}
      <DateCell value={model.AnlieferdatumEmpf} />
    </>
  ),
  LieferterminContainer: (model) => <DateCell value={model.LieferterminContainer} />,
  DatumZugestellt: (model) => <DateCell value={model.DatumZugestellt} />,
  DepotDatum: (model) => <DateCell value={model.DepotDatum} />,

  // Booleans
  EingangErledigt: (model) => <CheckboxCell value={model.EingangErledigt} />,
  TerminBestaetigungCif: (model) => (
    <>
      {rowColor(model)}
      <CheckboxCell value={model.TerminBestaetigungCif} />
    </>
  ),
  NaechsteKw: (model) => <CheckboxCell value={model.NaechsteKw} />,
};

export default containerCellTemplates;
